import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router-dom";

const style = {
  btn: {
    backgroundColor: "#323A45",
    border: "none",
    color: "white",
    padding: "8px 20px",
    textAlign: "center",
    textDecoration: "none",
    display: "inline-block",
    fontSize: "16px",
    marginLeft: "4px"
  },
  activeBtn: {
    backgroundColor: "#F5AA02",
    border: "none",
    color: "#323A45",
    padding: "8px 20px",
    textAlign: "center",
    textDecoration: "none",
    display: "inline-block",
    fontSize: "16px",
    marginLeft: "4px"
  },
  btnMargin: {
    marginRight: "4px"
  }
};

class SearchNavLink extends Component {
  render() {
    let pathname = this.props.history.location.pathname === this.props.to;
    let active = pathname
      ? "btn btn-highlight active"
      : "btn btn-standout active";

    return (
      <Link to={this.props.to}>
        <button className={active} style={style.btnMargin}>
          {this.props.name}
        </button>
      </Link>
    );
  }
}

export default withRouter(SearchNavLink);
